<div class="display-filter-container is-flex content-end">
    @for (icon of icons; let viewIndex = $index; track viewIndex) {
        <div class="display-filter-item is-flex mr-16">
            <button class="btn-tertiary icon-white" (click)="changeView(icon)" [attr.aria-label]="'Change Zoom ' + icon">
                <md-icon [name]="icon === iconSelected ? icon + '-active' : icon"></md-icon>
            </button>
        </div>
    }
</div>
